/* imageContainer-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./imageContainer-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { fileCardImageViewSelector } from '../../classnames';
var imageContainerStyles = null;
var imageContainerCenterStyles = null;
export var ImageContainer = function ImageContainer(_ref) {
  var children = _ref.children,
    mediaName = _ref.mediaName,
    status = _ref.status,
    progress = _ref.progress,
    selected = _ref.selected,
    source = _ref.source,
    centerElements = _ref.centerElements;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": fileCardImageViewSelector
    /**
     * This wrapper MUST add the classname in order to allow the editor to prevent bubbling up the click event.
     * See the method isInteractiveElement in source platform/packages/editor/renderer/src/ui/Renderer/click-to-edit.ts
     * Also, many other consumer tests rely on this selector.
     */
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: ax(["_1reo15vq _18m915vq _2rko1sit _1e0c1txw _kqswh2mm _p12f1osq _1bsb1osq _4t3i1osq _c71l1osq", centerElements && "_2lx21bp4 _1bah1h6o _4cvr1h6o", fileCardImageViewSelector]),
    "data-test-media-name": mediaName,
    "data-test-status": status,
    "data-test-progress": progress,
    "data-test-selected": selected,
    "data-test-source": source
  }, children);
};